"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomGrid = void 0;
const react_1 = __importStar(require("react"));
const authProvider_1 = require("@/components/authProvider/authProvider");
const principal_1 = require("@dfinity/principal");
const Section_1 = require("@/components/Section");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const format_1 = require("@/utils/format");
const styled_components_1 = __importDefault(require("styled-components"));
const formatDate_1 = require("@/utils/formatDate");
const react_router_dom_1 = require("react-router-dom");
const notistack_1 = require("notistack");
const rewardMulty = {
    "1": "1",
    "2": "1.25",
    "3": "1.5",
    "4": "2",
};
const config = {
    baseRate: 5,
    step: 1,
    min: 1,
    max: 5,
    steps: {
        1: 1,
        2: 1.15,
        3: 1.4,
        4: 1.65,
        5: 2,
    },
};
const StakesSpecific = () => {
    const { principal, accountID, loggedIn, isLoading: authLoading, ledgerActor, governanceActor, handleLogOut } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const [balance, setBalance] = (0, react_1.useState)(0n);
    const [stakedBalance, setStakedBalance] = (0, react_1.useState)(0n);
    const [isFollowModalOpened, setIsFollowModalOpened] = (0, react_1.useState)(false);
    const [isExtandOpen, setIsExtandOpen] = (0, react_1.useState)(false);
    const [stakes, setStakes] = (0, react_1.useState)([]);
    const [stake, setStake] = (0, react_1.useState)();
    const [rewardsSum, setRewardsSum] = (0, react_1.useState)(0n);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [metrics, setMetrics] = (0, react_1.useState)();
    const [stakeAmount, setStakeAmount] = (0, react_1.useState)("0");
    const [isProlonging, setIsProlonging] = (0, react_1.useState)(false);
    const [isDissolveChange, setIsDissolveChange] = (0, react_1.useState)(false);
    const [followPrincipal, setFollowPrincipal] = (0, react_1.useState)("");
    const [followIndex, setFollowIndex] = (0, react_1.useState)("");
    const [currentRewardRate, setCurrentRewardRate] = (0, react_1.useState)(0);
    const [extendPeriodDates, setExtendPeriodDates] = (0, react_1.useState)([]);
    const [selectedEndLockDate, setSelectedEndLockDate] = (0, react_1.useState)();
    const { id: sID } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const getBalances = async () => {
        setIsLoading(true);
        const balanceOGY = (await ledgerActor.account_balance_dfx({
            account: accountID,
        }));
        const extendDates = (await governanceActor.get_stake_periods());
        const balanceGovernance = await governanceActor.get_balances();
        const mappedStakes = balanceGovernance.staked.reduce((arr, item) => {
            return [...arr, { ...item[1], id: item[0] }];
        }, []);
        const stakedTokensSum = balanceGovernance.staked.reduce((acc, token) => {
            return acc + token[1].quantity;
        }, 0n);
        const sorted = Object.values(extendDates).sort();
        setExtendPeriodDates(sorted.map((v, i) => ({ value: v, label: `${i + 1} Years. Ends in ${(0, formatDate_1.formatTime)(v)}` })));
        setStakes(mappedStakes);
        setBalance(balanceOGY.e8s);
        setStakedBalance(stakedTokensSum);
        setIsLoading(false);
    };
    const handleUnstake = async () => {
        try {
            const p = principal_1.Principal.fromText(principal.toString());
            if (principal.toString() === "2vxsx-fae")
                return handleLogOut();
        }
        catch {
            handleLogOut();
        }
        try {
            if (!governanceActor)
                throw new Error("governance actor error");
            enqueueSnackbar("Unstaking Stake", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            const index = await governanceActor.unstake_tokens(BigInt(sID));
            const resp = await governanceActor.withdraw_unlocked_tokens(accountID, stake.quantity + rewardsSum - 200000n);
            enqueueSnackbar("Unstaked successfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            navigate("/stakes");
        }
        catch (e) {
            console.error({ e });
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
    };
    const handleReddemRewards = async (merge = false) => {
        try {
            const p = principal_1.Principal.fromText(principal.toString());
            if (principal.toString() === "2vxsx-fae")
                return handleLogOut();
        }
        catch {
            handleLogOut();
        }
        try {
            if (!governanceActor)
                throw new Error("governance actor error");
            enqueueSnackbar(merge ? "Merging rewards" : "Redeeming rewards", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            const index = await governanceActor.redeem_rewards_v1_5(BigInt(sID), merge, []);
            enqueueSnackbar(merge ? "Merged succesfully" : "Redeemed succesfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            navigate("/stakes");
        }
        catch (e) {
            console.error({ e });
            enqueueSnackbar(e.message ? (e.message.includes("100_000_000") ? "Minimum amount is 1000 OGY" : e.message) : "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
    };
    const handleDissolve = async (is_dissolving) => {
        setIsDissolveChange(true);
        try {
            if (!governanceActor)
                throw new Error("gov actor failed to instantiate");
            const res = await governanceActor.manage_stake({
                stake_type: {
                    staked: null,
                },
                command: {
                    updateDissolve: !is_dissolving,
                },
                index: parseInt(sID),
            });
            if (res) {
                getBalances();
                enqueueSnackbar("Dissolve status changed", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
            else {
            }
        }
        catch (e) {
            console.error({ e });
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsDissolveChange(false);
    };
    const handleExtend = async () => {
        setIsProlonging(true);
        try {
            if (!governanceActor)
                throw new Error("vesting actor failed to instantiate");
            const res = await governanceActor.manage_stake({
                stake_type: {
                    staked: null,
                },
                command: {
                    updateEndLockTime: selectedEndLockDate.value,
                },
                index: parseInt(sID),
            });
            if (res) {
                await getBalances();
                setIsProlonging(false);
                setIsExtandOpen(false);
                enqueueSnackbar("Stake extended", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
            else {
                enqueueSnackbar("Failed", {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
        }
        catch (e) {
            console.error({ e });
            alert("Failed...");
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsProlonging(false);
    };
    const unfollowHandler = async () => {
        try {
            const res = await governanceActor.manage_stake({
                stake_type: {
                    "staked": null,
                },
                command: {
                    follow: []
                },
                index: parseInt(sID),
            });
            if (res) {
                getBalances();
                enqueueSnackbar("Stake unfollowed", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
            else {
            }
        }
        catch (e) {
            console.error("error", { e });
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
    };
    const onUpdateFollowing = async () => {
        try {
            const res = await governanceActor.manage_stake({
                stake_type: {
                    "staked": null,
                },
                command: {
                    //BigInt(followIndex) * 1000000n
                    follow: [[principal_1.Principal.fromText(followPrincipal), BigInt(followIndex)]]
                },
                index: parseInt(sID),
            });
            if (res) {
                getBalances();
                setIsFollowModalOpened(false);
            }
            else {
            }
        }
        catch (e) {
            console.error("error", { e });
        }
    };
    const isGracedStake = () => {
        const endDate = new Date();
        endDate.setDate(endDate.getDate() + 14);
        // Mon Sep 18 2023 19:00:00 CET+2 1695052800000
        return ((0, formatDate_1.dateFromNanos)(stake?.createdDate).getTime() < 1695052800000) && (Date.now() < endDate.getTime());
    };
    const getData = async () => {
        const metrics = await governanceActor.get_metrics();
        const totalLocked = Number(metrics.locked_tier_1) * config.steps[1]
            + Number(metrics.locked_tier_2) * config.steps[2]
            + Number(metrics.locked_tier_3) * config.steps[3]
            + Number(metrics.locked_tier_4) * config.steps[4]
            + Number(metrics.locked_tier_5) * config.steps[5];
        setCurrentRewardRate((Number(metrics.current_epic_rewards)) / (Number(totalLocked)));
        //setCurrentRewardRate(0.05);
        setMetrics(metrics);
    };
    (0, react_1.useEffect)(() => {
        if (stakes.length) {
            const s = stakes.find(({ id }) => id === BigInt(parseInt(sID)));
            const rewards = s?.rewards.reduce((sum, reward) => sum + reward.amount, 0n);
            setExtendPeriodDates(extendPeriodDates.filter((t) => s.endLockTime < t.value));
            setStake(s);
            setRewardsSum(rewards);
        }
    }, [stakes]);
    (0, react_1.useEffect)(() => {
        if (loggedIn && !authLoading) {
            getBalances();
            getData();
        }
        else {
            navigate('/');
        }
    }, [authLoading, loggedIn, governanceActor]);
    return (react_1.default.createElement(Section_1.Section, null,
        stake && (react_1.default.createElement(exports.CustomGrid, null,
            react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "NAVIGATION_BACKGROUND", padding: "24px 26px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", gap: 24 },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, justify: "space-between", smFlexFlow: 'column' },
                        react_1.default.createElement("p", null,
                            "Stake ID: ",
                            sID),
                        react_1.default.createElement("p", null,
                            "Date Created ",
                            (0, formatDate_1.formatTime)(stake?.createdDate))),
                    react_1.default.createElement(origyn_art_ui_1.HR, null),
                    react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", justify: "space-between" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column" },
                            react_1.default.createElement("h6", null, "Staked OGY"),
                            react_1.default.createElement("h1", null, (0, format_1.formatNatAmount)(stake?.quantity))),
                        react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleUnstake }, "Unstake")),
                    react_1.default.createElement(origyn_art_ui_1.Grid, { columns: 3, gap: 24 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", justify: "space-between", gap: 4 },
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("b", null, "Dissolve Delay")),
                            react_1.default.createElement("p", null, (0, formatDate_1.getDiffInDays)(stake?.endLockTime)),
                            react_1.default.createElement("br", null),
                            react_1.default.createElement(origyn_art_ui_1.Button, { btnType: 'filled', disabled: isProlonging, onClick: () => setIsExtandOpen(true) }, isProlonging ? "Prolonging Stake..." : "Extend")),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", justify: "space-between", gap: 4 },
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("b", null, "Dissolving")),
                            react_1.default.createElement("p", null,
                                stake?.dissolving ? "Yes " : "No ",
                                "(",
                                (0, formatDate_1.formatTime)(stake?.endLockTime),
                                ")"),
                            stake?.dissolving ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("b", { style: { color: 'red' } }, "Dissolving stake can effect your rewards!"))) : (react_1.default.createElement("br", null)),
                            stake?.dissolving ? (react_1.default.createElement(origyn_art_ui_1.Button, { btnType: 'filled', onClick: () => handleDissolve(stake?.dissolving), disabled: isDissolveChange }, "Stop Dissolving")) : (react_1.default.createElement(origyn_art_ui_1.Button, { btnType: 'filled', onClick: () => handleDissolve(stake?.dissolving), disabled: isDissolveChange }, "Start Dissolving"))),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", justify: "space-between", gap: 4 },
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("b", null, "Staking Rewards")),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { align: "center", gap: 8 },
                                react_1.default.createElement("span", null,
                                    (0, format_1.formatNatAmount)(rewardsSum),
                                    " OGY"),
                                react_1.default.createElement(origyn_art_ui_1.Button, { size: "small", disabled: !rewardsSum, onClick: () => handleReddemRewards(true) }, "Merge")),
                            react_1.default.createElement("br", null),
                            react_1.default.createElement(origyn_art_ui_1.Button, { btnType: 'filled', disabled: rewardsSum < 100000n, onClick: () => handleReddemRewards() }, "Claim Rewards"))),
                    react_1.default.createElement(origyn_art_ui_1.HR, null),
                    react_1.default.createElement("h6", null, "Staking Rewards Breakdown"),
                    react_1.default.createElement(origyn_art_ui_1.Card, { padding: "16px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, justify: 'space-between', align: "center", smFlexFlow: 'column' },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', align: "center" },
                                react_1.default.createElement("p", null, "Base Reward Rate"),
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("b", null,
                                        ((currentRewardRate || 0) * 100).toFixed(2),
                                        "%"))),
                            react_1.default.createElement("div", null, "+"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', align: "center" },
                                react_1.default.createElement("p", null, "Reward Multiplier"),
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("b", null,
                                        stake?.classification.toString(),
                                        "x"))),
                            react_1.default.createElement("div", null, "="),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', align: "center" },
                                react_1.default.createElement("p", null, "Effective Reward Rate"),
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("b", null,
                                        (((currentRewardRate || 0) * 100) * stake?.classification).toFixed(2),
                                        "%"))))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "NAVIGATION_BACKGROUND", padding: "24px 26px" },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24, fullWidth: true },
                        react_1.default.createElement("h6", null, "Delegated Voting"),
                        react_1.default.createElement(origyn_art_ui_1.HR, null),
                        stake.follow?.length ? (react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24, fullWidth: true },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8 },
                                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none" },
                                    react_1.default.createElement("path", { d: "M5.67313 20.7897H2.56313C1.70125 20.7897 1 20.0958 1 19.2423V9.96823C1 9.1154 1.70125 8.4209 2.56313 8.4209H5.67313C6.535 8.4209 7.23688 9.1154 7.23688 9.96823V19.2423C7.23688 20.0958 6.535 20.7897 5.67313 20.7897ZM2.56313 9.65778C2.39063 9.65778 2.25 9.79692 2.25 9.96823V19.2423C2.25 19.413 2.39063 19.5528 2.56313 19.5528H5.67313C5.84625 19.5528 5.98688 19.413 5.98688 19.2423V9.96823C5.98688 9.79692 5.84625 9.65778 5.67313 9.65778H2.56313Z", fill: "#5EAC31", stroke: "#5EAC31", "stroke-width": "0.5" }),
                                    react_1.default.createElement("path", { d: "M17.1282 20.79H9.5532C9.16758 20.79 8.78195 20.6997 8.43633 20.529L6.33133 19.4876C6.02258 19.3348 5.89758 18.9632 6.05195 18.6576C6.20633 18.3521 6.58133 18.2285 6.8907 18.3812L8.9957 19.4227C9.1682 19.508 9.3607 19.5531 9.5532 19.5531H17.1282C17.3563 19.5531 17.5688 19.4313 17.6826 19.2347L18.3882 18.0126C19.2701 16.4857 19.7363 14.7479 19.7363 12.989V10.8962C19.7363 10.2135 19.1751 9.65814 18.4851 9.65814H13.7807C13.3663 9.65814 12.9801 9.45529 12.7476 9.11577C12.5157 8.77624 12.4688 8.34581 12.6226 7.96547C13.1957 6.54801 13.4863 5.05448 13.4863 3.52632V2.80955C13.4863 2.49415 13.227 2.23688 12.9076 2.23688H12.5188C12.262 2.23688 12.0332 2.40757 11.9626 2.65185L11.7176 3.49973C11.1926 5.31608 10.322 6.98463 9.12945 8.46022C8.51445 9.22152 7.59695 9.65814 6.61133 9.65814H4.73633C4.39133 9.65814 4.11133 9.38108 4.11133 9.0397C4.11133 8.69832 4.39133 8.42126 4.73633 8.42126H6.61133C7.21445 8.42126 7.77695 8.15348 8.15383 7.68717C9.24195 6.34021 10.037 4.817 10.5157 3.15959L10.7607 2.31171C10.9838 1.5399 11.707 1 12.5188 1H12.9076C13.9163 1 14.7363 1.81139 14.7363 2.80955V3.52632C14.7363 5.2128 14.4151 6.86094 13.7832 8.42497L18.4851 8.42126C19.8645 8.42126 20.9863 9.53136 20.9863 10.8962V12.989C20.9863 14.9631 20.4632 16.913 19.4732 18.6267L18.7676 19.8488C18.432 20.4295 17.8038 20.79 17.1282 20.79Z", fill: "#5EAC31", stroke: "#5EAC31", "stroke-width": "0.5" }),
                                    react_1.default.createElement("path", { d: "M4.11133 18.316C4.45651 18.316 4.73633 18.0391 4.73633 17.6975C4.73633 17.356 4.45651 17.0791 4.11133 17.0791C3.76615 17.0791 3.48633 17.356 3.48633 17.6975C3.48633 18.0391 3.76615 18.316 4.11133 18.316Z", fill: "#5EAC31", stroke: "#5EAC31", "stroke-width": "0.5" })),
                                react_1.default.createElement("span", null, "Following")),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("p", null, "You are following this stake:"),
                                react_1.default.createElement("p", null, stake?.follow[0][0].toString())),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                                react_1.default.createElement(origyn_art_ui_1.Button, { onClick: unfollowHandler }, "Unfollow")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8 },
                                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "21", height: "20", viewBox: "0 0 21 20", fill: "none" },
                                    react_1.default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.7566 0C5.3385 0 0.958984 4.47 0.958984 10C0.958984 15.53 5.3385 20 10.7566 20C16.1746 20 20.5541 15.53 20.5541 10C20.5541 4.47 16.1746 0 10.7566 0ZM13.2941 6L10.7566 8.59L8.21898 6L6.83753 7.41L9.3751 10L6.83753 12.59L8.21898 14L10.7566 11.41L13.2941 14L14.6756 12.59L12.138 10L14.6756 7.41L13.2941 6ZM2.9185 10C2.9185 14.41 6.43583 18 10.7566 18C15.0773 18 18.5946 14.41 18.5946 10C18.5946 5.59 15.0773 2 10.7566 2C6.43583 2 2.9185 5.59 2.9185 10Z", fill: "#E42932" })),
                                react_1.default.createElement("b", null, "Not Following")),
                            react_1.default.createElement("p", null,
                                "You are not following any stakes. You need to manually vote on proposals or ",
                                react_1.default.createElement("b", { style: { color: 'red' } }, "you will not receive rewards"),
                                "."),
                            react_1.default.createElement(origyn_art_ui_1.Button, { onClick: () => setIsFollowModalOpened(true) }, "Follow a Stake")))))))),
        react_1.default.createElement(origyn_art_ui_1.Modal, { size: "md", isOpened: isFollowModalOpened, closeModal: () => setIsFollowModalOpened(false) },
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                        react_1.default.createElement("h6", null, "Manage Voting Delegates"),
                        react_1.default.createElement("p", null, "Your vote has been submitted and you can safely close this window.")),
                    react_1.default.createElement(origyn_art_ui_1.TextInput, { value: followPrincipal, onChange: (e) => setFollowPrincipal(e.target.value), label: "Principal ID" }),
                    react_1.default.createElement(origyn_art_ui_1.TextInput, { value: followIndex, onChange: (e) => setFollowIndex(e.target.value), label: "Stake Index" }),
                    react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'flex-end' },
                        react_1.default.createElement(origyn_art_ui_1.Button, { onClick: onUpdateFollowing, btnType: 'filled' }, "Save Changes"))))),
        react_1.default.createElement(origyn_art_ui_1.Modal, { size: "md", isOpened: isExtandOpen, closeModal: () => setIsExtandOpen(false) },
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                        react_1.default.createElement("h6", null, "Extend stake"),
                        react_1.default.createElement("p", null, "Select for how many years you wont your stake to be locked")),
                    isProlonging ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("br", null),
                        react_1.default.createElement("h4", null, "Updating a stake..."),
                        react_1.default.createElement("br", null))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(origyn_art_ui_1.Select, { selectedOption: selectedEndLockDate, options: extendPeriodDates, handleChange: setSelectedEndLockDate }),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'flex-end' },
                            react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleExtend, btnType: 'filled' }, "Extend stake")))))))));
};
exports.default = StakesSpecific;
exports.CustomGrid = styled_components_1.default.div `
  max-width: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 24px;

  ${({ theme }) => theme.media.lg} {
    grid-template-columns: 2fr 1fr;
  }
  ${({ theme }) => theme.media.sm} {
    grid-template-columns: 1fr;
  }
`;
